import { template as template_75d78558255e47e48910f353da9d5649 } from "@ember/template-compiler";
import type { TemplateOnlyComponent } from '@ember/component/template-only';
import RouteTemplate from 'ember-route-template';
import type { Model } from '../../routes/render/icon';
export default RouteTemplate(template_75d78558255e47e48910f353da9d5649(`
  <@model.Component />
`, {
    eval () {
        return eval(arguments[0]);
    }
}) satisfies TemplateOnlyComponent<{
    Args: {
        model: Model;
    };
}>);
